export default __webpack_public_path__ + "static/media/down-chevron-icon.aa25dfb8.svg";